"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _generateNewId = require("../../../generateNewId.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  show: true,
  title: 'My Table',
  description: '',
  columns: [{
    id: 'column0',
    label: 'Client ID',
    description: '',
    tooltip: true,
    render: 'abs',
    visualize: true
  }, {
    id: 'column1',
    label: 'Number sessions attended of total sessions',
    description: '',
    tooltip: true,
    render: 'xy',
    visualize: true
  }]
};
var columnRenderOptions = [{
  value: '',
  label: '-- Choose renderer --'
}, {
  value: 'xy',
  label: 'X/Y'
}, {
  value: 'abs',
  label: 'Absolute'
}, {
  value: 'percent',
  label: 'Percent'
}];
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Table Builder?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "description",
    component: _cccisdFormik.CccisdInput,
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: "columns",
    render: function render(_ref) {
      var form = _ref.form,
        remove = _ref.remove,
        push = _ref.push,
        name = _ref.name;
      // console.log(form);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        field: {
          name: name
        },
        form: form,
        label: "Table Columns"
      }, /*#__PURE__*/_react["default"].createElement("div", null, form.values.columns.map(function (column, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "panel panel-default"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "panel-heading"
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "panel-title"
        }, "Column ".concat(index + 1))), /*#__PURE__*/_react["default"].createElement("div", {
          className: "panel-body"
        }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns[".concat(index, "].label"),
          component: _cccisdFormik.CccisdInput,
          label: "Label"
        }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns[".concat(index, "].description"),
          component: _cccisdFormik.CccisdInput,
          label: "Description"
        }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns.".concat(index, ".tooltip"),
          component: _cccisdFormik.CccisdToggle,
          label: "Use description for column tooltip?"
        }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns.".concat(index, ".render"),
          component: _cccisdFormik.CccisdSelect,
          label: "Renderer",
          options: columnRenderOptions
        }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
          name: "columns.".concat(index, ".visualize"),
          component: _cccisdFormik.CccisdToggle,
          label: "Visualize?"
        }))), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Remove column ".concat(index + 1)
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-xs btn-danger",
          onClick: function onClick() {
            return remove(index);
          }
        }, "-")));
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          return push({
            id: (0, _generateNewId.generateNewId)({
              prefix: 'column',
              settings: form.values.columns
            }),
            label: '',
            visualize: false
          });
        }
      }, "+ Add Column")));
    }
  }));
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.widgetBuilder)({
  initialValues: initialValues
})(Component);